import { useNavigate, useParams } from "react-router-dom";
import "./itemInfo.css";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import AddPhoto from "../../assets/svg/AddPhoto.svg";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Camera from "../../assets/svg/Camera.svg";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import DeleteModal from "../../components/Modals/DeleteModal";
import { useSelector } from "react-redux";

export default function VariationProfile() {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const [show, setShow] = useState(false);

  const { id, subCatId, brandId, productId } = useParams();

  const handleDeleteProduct = () => {
    setShow(!show);
  };

  const [productData, setProductData] = useState(null);

  const [categoryId, setCategoryId] = useState(null);

  const [productBrandId, setProductBrandId] = useState(null);

  const getProductInfo = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/product_variations/${productId}`,
        { headers }
      );
      console.log(response.data.data.variation);
      setProductData(response.data.data.variation);
      setCategoryId(response.data.data.variation?.product?.category?.id);
      setProductBrandId(response.data.data.variation?.product?.brand?.id);
    } catch (error) {
      console.log(error);
    }
  };

  const navigate = useNavigate();

  const goToBatches = () => {
    navigate(
      id && subCatId && brandId && productId
        ? `/Categories/${id}/subcategory/${subCatId}/brand/${brandId}/Products/${productId}/Batches`
        : id && brandId && productId
        ? `/Categories/${id}/brand/${brandId}/Products/${productId}/Batches`
        : id && productId
        ? `/Brands/${id}/Products/${productId}/Batches`
        : `/stock/${productId}/batches`
    );
  };

  // edit product

  const newHost = "https://estbn.com/EstbnNew/public/api/";

  const newHeaders = {
    Authorization: "Bearer " + token,
  };

  // const newHeaders = { Authorization: `Bearer 1|uXWWHVAxUbLR94IuQ07nZUT5306vlnjfGFo4AUoR16bcf002` }

  const [properties, setProperties] = useState([]);

  const [units, setUnits] = useState([]);

  const [status, setStatus] = useState([]);

  const [showEdit, setShowEdit] = useState(false);

  const handleCloseEdit = () => {
    setShowEdit(false);
  };

  const [addMainCatigory, setAddMainCatigory] = useState({
    profile_image: "",
    description: "",
    name: "",
    product_status: "",
    reorder_point: "",
    weight: "",
    unit_id: "",
    dimensions: "",
    property_values: [],
  });

  const getProperties = async () => {
    try {
      const response = await axios.get(
        `${newHost}product_selections?category_id=${categoryId}`,
        {
          headers: newHeaders,
        }
      );
      console.log(response);
      setProperties(response.data.data.properties);
      setUnits(response.data.data.units);
      setStatus(response.data.data.product_statuses);
    } catch (error) {
      console.log(error.message);
    }
  };

  const onSubmitAddMainCatogiry = () => {
    const formData = new FormData();

    formData.append("_method", "PUT");
    formData.append("category_id", categoryId);
    formData.append("brand_id", productBrandId);
    formData.append("profile_image", addMainCatigory.profile_image);
    formData.append("name", addMainCatigory.name);
    formData.append("description", addMainCatigory.description);
    formData.append("product_status", addMainCatigory.product_status);
    formData.append(
      "reorder_point",
      parseInt(addMainCatigory.reorder_point || 0, 10)
    );
    formData.append("weight", addMainCatigory.weight);
    formData.append("unit_id", addMainCatigory.unit_id);
    formData.append("dimensions", addMainCatigory.dimensions);
    if (Array.isArray(addMainCatigory.property_values)) {
      addMainCatigory.property_values.forEach((item, index) => {
        formData.append(
          `property_values[${index}][property_id]`,
          item.property_id
        );
        formData.append(
          `property_values[${index}][property_value_id]`,
          item.property_value_id
        );
      });
    }

    const url = `${newHost}portal/products-with-variations/${productId}`;

    axios
      .post(url, formData, {
        headers: newHeaders,
      })
      .then((response) => {
        console.log(response.data);
        toast.success("Product Updated Successfully", { autoClose: 3000 });
        setShowEdit(false);
        getProductInfo();
        setAddMainCatigory({
          profile_image: "",
          description: "",
          name: "",
          product_status: "",
          reorder_point: "",
          weight: "",
          unit_id: "",
          dimensions: "",
          property_values: [],
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  const handleEditCategory = () => {
    const fullImageUrl = productData?.profile_image_url?.startsWith("http")
      ? productData.profile_image_url
      : productData?.profile_image_url
      ? `https://estbn.com/EstbnNew/public${productData.profile_image_url}`
      : "";

    const mappedPropertyValues = [];
    const propertyValueMap = {};

    if (
      productData.property_values &&
      Array.isArray(productData.property_values)
    ) {
      productData.property_values.forEach((propVal) => {
        const propertyId = Number(propVal.property_id);
        const matchingProp = properties.find((p) => p.id === propertyId);

        if (matchingProp) {
          const matchedValue = matchingProp.values.find(
            (v) => v.value === propVal.value
          );

          if (matchedValue) {
            mappedPropertyValues.push({
              property_id: propertyId,
              property_value_id: matchedValue.id,
            });

            propertyValueMap[propertyId] = matchedValue.id;
            setValue(`property_values.${propertyId}`, matchedValue.id);
          }
        }
      });
    }

    setAddMainCatigory({
      profile_image: "",
      description: productData.description,
      name: productData.name,
      product_status: productData.status,
      reorder_point: productData.reorder_point,
      weight: productData.weight,
      unit_id: productData.unit?.id,
      dimensions: productData.dimensions,
      property_values: mappedPropertyValues,
      fileUrl: fullImageUrl,
    });

    setValue("name", productData.name);
    setValue("description", productData.description);
    setValue("product_status", productData.status);
    setValue("reorder_point", productData.reorder_point);
    setValue("weight", productData.weight);
    setValue("unit_id", productData.unit?.id);
    setValue("dimensions", productData.dimensions);
    setShowEdit(true);
  };

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors, isSubmitting },
  } = useForm();

  // delete product

  const [showDelete, setShowDelete] = useState(false);

  const handleDeleteClose = () => {
    setShowDelete(false);
  };

  const confirmDelete = () => {
    setShowDelete(true);
  };

  const deleteProduct = async () => {
    try {
      let response = await axios.delete(
        `${newHost}portal/products-with-variations/${productId}`,
        {
          headers: newHeaders,
        }
      );
      toast.warning("Product Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      navigate(
        id && subCatId && brandId
          ? `/Categories/${id}/subcategory/${subCatId}/brand/${brandId}`
          : id && brandId
          ? `/Categories/${id}/brand/${brandId}`
          : id
          ? `/brands/${id}`
          : "/stock"
      );
    } catch (error) {
      toast.error("Failed To Delete This Product.");
      console.log(error.message);
    }
  };

  useEffect(() => {
    getProductInfo();
    getProperties();
  }, [categoryId]);

  return (
    <div>
      {/* edit product  */}
      <Modal show={showEdit} onHide={handleCloseEdit}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            Update Product
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmitAddMainCatogiry)}>
            {/* image  */}
            <div className="flex-center-x-y">
              <input
                type="file"
                accept="image/jpeg,image/png,image/jpg,image/gif,image/webp"
                style={{ display: "none" }}
                id="icon_url"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const allowedTypes = [
                      "image/jpeg",
                      "image/png",
                      "image/jpg",
                      "image/svg+xml",
                      "image/gif",
                      "image/webp",
                    ];
                    if (allowedTypes.includes(file.type)) {
                      const imageUrl = URL.createObjectURL(file);
                      setAddMainCatigory({
                        ...addMainCatigory,
                        profile_image: file,
                        fileUrl: imageUrl,
                      });
                    } else {
                      toast.error("Please select a valid image file.");
                      setAddMainCatigory({
                        ...addMainCatigory,
                        profile_image: "",
                        fileUrl: "",
                      });
                    }
                  }
                }}
              />
              <label htmlFor="icon_url" className="categories_photo">
                {addMainCatigory.fileUrl ? (
                  <img
                    className="categories-add"
                    src={addMainCatigory.fileUrl}
                    alt="Selected"
                  />
                ) : (
                  <>
                    <img
                      className="categories-add"
                      src={AddPhoto}
                      alt="Placeholder"
                    />
                    <div className="categories_cameraIcon">
                      <img src={Camera} alt="Camera Icon" />
                    </div>
                  </>
                )}
              </label>
              {errors.profile_image && (
                <p className="danger">{errors.profile_image.message}</p>
              )}
            </div>
            {/* name */}
            <div className="row">
              <div className="col-12">
                <TextField
                  className="w-100 mb-3"
                  label="Name"
                  placeholder="Enter Name"
                  variant="outlined"
                  value={addMainCatigory.name}
                  {...register("name", {
                    required: "Name Is Required",
                    onChange: (e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        name: e.target.value,
                      });
                    },
                  })}
                />
                {errors.name && <p className="danger">{errors.name.message}</p>}
              </div>
            </div>
            {/* unit & status  */}
            <div className="row">
              {/* unit  */}
              <div className="col-6">
                <Controller
                  name="unit_id"
                  control={control}
                  rules={{ required: "Unit is required" }}
                  render={({ field }) => (
                    <FormControl
                      className="w-100 mb-3"
                      variant="outlined"
                      error={!!errors.unit_id}
                    >
                      <InputLabel id="unit-label">Unit</InputLabel>
                      <Select
                        labelId="unit-label"
                        label="Unit"
                        {...field}
                        value={field.value || ""}
                        onChange={(e) => {
                          field.onChange(e);
                          setAddMainCatigory((prev) => ({
                            ...prev,
                            unit_id: e.target.value,
                          }));
                        }}
                      >
                        {units.map((unit) => (
                          <MenuItem
                            key={unit.id}
                            className="custom-menu-item"
                            value={unit.id}
                          >
                            {unit.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
                {errors.unit_id && (
                  <p className="danger">{errors.unit_id.message}</p>
                )}
              </div>
              {/* status  */}
              <div className="col-6">
                <Controller
                  name="product_status"
                  control={control}
                  rules={{ required: "Status is required" }}
                  render={({ field }) => (
                    <FormControl
                      className="w-100 mb-3"
                      variant="outlined"
                      error={!!errors.product_status}
                    >
                      <InputLabel id="status-label">Status</InputLabel>
                      <Select
                        labelId="status-label"
                        label="Status"
                        {...field}
                        value={field.value || ""}
                        onChange={(e) => {
                          field.onChange(e);
                          setAddMainCatigory((prev) => ({
                            ...prev,
                            product_status: e.target.value,
                          }));
                        }}
                      >
                        {status.map((st) => (
                          <MenuItem
                            className="custom-menu-item"
                            key={st.value}
                            value={st.value}
                          >
                            {st.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
                {errors.product_status && (
                  <p className="danger">{errors.product_status.message}</p>
                )}
              </div>
            </div>
            {/* weight & dimensions  */}
            <div className="row">
              {/* weight  */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-3"
                  label="Weight"
                  placeholder="Enter Weight"
                  variant="outlined"
                  value={addMainCatigory.weight}
                  {...register("weight", {
                    required: "Weight Is Required",
                    onChange: (e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        weight: e.target.value,
                      });
                    },
                  })}
                />
                {errors.weight && (
                  <p className="danger">{errors.weight.message}</p>
                )}
              </div>
              {/* dimensions */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-3"
                  label="Dimensions"
                  placeholder="Enter Dimensions"
                  variant="outlined"
                  {...register("dimensions", {
                    required: "Dimensions Is Required",
                    onChange: (e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        dimensions: e.target.value,
                      });
                    },
                  })}
                  value={addMainCatigory.dimensions}
                />
                {errors.dimensions && (
                  <p className="danger">{errors.dimensions.message}</p>
                )}
              </div>
            </div>
            {/* reorder & properties */}
            <div className="row">
              {/* reorder  */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-3"
                  type="number"
                  label="Reorder Point"
                  placeholder="Enter Number"
                  variant="outlined"
                  {...register("reorder_point", {
                    required: "Reorder_point Is Required",
                    onChange: (e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        reorder_point: e.target.value,
                      });
                    },
                  })}
                  value={addMainCatigory.reorder_point}
                />
                {errors.reorder_point && (
                  <p className="danger">{errors.reorder_point.message}</p>
                )}
              </div>
              {/* properties  */}
              {properties.map((prop) => (
                <div className="col-6" key={prop.id}>
                  <Controller
                    name={`property_values.${prop.id}`}
                    control={control}
                    rules={{ required: `${prop.name} is required` }}
                    render={({ field }) => (
                      <FormControl
                        className="w-100 mb-3"
                        variant="outlined"
                        error={!!errors.property_values?.[prop.id]}
                      >
                        <InputLabel id={`prop-${prop.id}`}>
                          {prop.name}
                        </InputLabel>
                        <Select
                          labelId={`prop-${prop.id}`}
                          label={prop.name}
                          value={field.value || ""}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            field.onChange(selectedValue);

                            const currentProperties = Array.isArray(
                              addMainCatigory.property_values
                            )
                              ? addMainCatigory.property_values
                              : [];

                            const updatedValues = currentProperties.map(
                              (item) => {
                                if (item.property_id === prop.id) {
                                  return {
                                    ...item,
                                    property_value_id: selectedValue,
                                  };
                                }
                                return item;
                              }
                            );

                            const isExisting = currentProperties.some(
                              (item) => item.property_id === prop.id
                            );

                            const finalValues = isExisting
                              ? updatedValues
                              : [
                                  ...currentProperties,
                                  {
                                    property_id: prop.id,
                                    property_value_id: selectedValue,
                                  },
                                ];

                            setAddMainCatigory((prev) => ({
                              ...prev,
                              property_values: finalValues,
                            }));
                          }}
                        >
                          {prop.values.map((value) => (
                            <MenuItem
                              key={value.id}
                              className="custom-menu-item"
                              value={value.id}
                            >
                              {value.value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                  {errors.property_values?.[prop.id] && (
                    <p className="danger">
                      {errors.property_values[prop.id]?.message}
                    </p>
                  )}
                </div>
              ))}
            </div>
            {/* description  */}
            <div className="row">
              <div className="col-12">
                <TextField
                  className="w-100 mb-3"
                  label="Category Description"
                  variant="outlined"
                  rows={4}
                  multiline
                  {...register("description", {
                    required: "Description Is Required",
                    onChange: (e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        description: e.target.value,
                      });
                    },
                  })}
                  value={addMainCatigory.description}
                />
                {errors.description && (
                  <p className="danger">{errors.description.message}</p>
                )}
              </div>
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleCloseEdit}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* delete product  */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this product?"}
        deleteFunction={deleteProduct}
      />
      {/* Suspend Modal */}
      <Modal show={show} onHide={handleDeleteProduct}>
        <Modal.Header>
          <Modal.Title className="text-center fs-3 fw-semibold">
            Suspend Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center fs-4 text-muted">
            Are you want to suspend this product
          </div>
          <div className="text-center fs-4 fw-semibold my-1">
            “ Shell Oil 5W-30 “?
          </div>
          <div className="OrdersTable-footer">
            <button onClick={handleDeleteProduct} className="ordersCancelTable">
              Cancel
            </button>
            <button
              onClick={handleDeleteProduct}
              className=" deletOrderbutton_sus "
            >
              Suspend
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {/* Product Info Details */}
      <div className="mx-4 my-3">
        {/* Header */}
        <div className="row mx-auto">
          <div className="col-12 col-xl-2 text-xl-start px-0">
            <h3 className="mb-0">Product Profile</h3>
          </div>
          <div className="col-6 d-flex justify-content-center">
            <button className="btn btn-dark ms-5 stock-button">
              Product Info
            </button>
            <button
              onClick={goToBatches}
              className="btn border border-1 bg-light stock-button"
            >
              Batches
            </button>
          </div>
          <div className="col-12 col-sm-8 col-md-4 mx-sm-auto text-xl-end px-0">
            <button
              onClick={handleDeleteProduct}
              className="btn text-white stock-button"
              style={{ backgroundColor: "#EA295E" }}
            >
              Inactive Product
            </button>
          </div>
        </div>
        {/* Product Details */}
        <div className="border border-2 rounded-3 my-3 p-3">
          {/* Top Row */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center border-bottom pb-3">
            <p className="fs-5 fw-semibold mb-0">{productData?.sku}</p>
            <div className="d-flex gap-2">
              <button
                className="btn btn-light"
                onClick={() => handleEditCategory()}
              >
                <i className="fa-solid fa-pencil text-muted me-1"></i> Edit
              </button>
              <button className="btn btn-light" onClick={() => confirmDelete()}>
                <i className="fa-solid fa-trash-can text-danger"></i>
              </button>
            </div>
          </div>
          {/* Basic Info */}
          <div className="py-2">
            <p className="fs-5 fw-semibold mb-2">Product Info:</p>
            <div className="row gy-3">
              <div className="col-sm-6 col-lg-4">
                <div className="fw-semibold d-flex align-items-center gap-2">
                  <span className="text-muted">Category:</span>
                  <img
                    src={`${newBaseUrl}${productData?.product?.category?.image_url}`}
                    style={{ width: 25, height: 25, objectFit: "cover" }}
                    alt=""
                  />
                  <p className="mb-0">{productData?.product?.category?.name}</p>
                </div>
              </div>
              <div className="col-sm-6 col-lg-4">
                <span className="text-muted fw-semibold">Brand:</span>{" "}
                {productData?.product?.brand?.name}
              </div>
              <div className="col-sm-6 col-lg-4">
                <span className="text-muted fw-semibold">Dimensions:</span>{" "}
                {productData?.dimensions || "undefined"}
              </div>
              <div className="col-sm-6 col-lg-4">
                <span className="text-muted fw-semibold">Item Name:</span>{" "}
                {productData?.sku}
              </div>
              <div className="col-sm-6 col-lg-4">
                <span className="text-muted fw-semibold">Unit:</span>{" "}
                {productData?.unit?.name}
              </div>
              <div className="col-sm-6 col-lg-4">
                <span className="text-muted fw-semibold">Re-order Point:</span>{" "}
                <i
                  className="fa-solid fa-circle fa-sm pe-1"
                  style={{ color: `${productData?.stock_status_color}` }}
                ></i>
                {productData?.stock_status}
              </div>
              <div className="col-sm-6 col-lg-4">
                <span className="text-muted fw-semibold">Weight:</span>{" "}
                {productData?.weight}
              </div>
              <div className="col-sm-6 col-lg-4">
                <span className="text-muted fw-semibold">Status:</span>{" "}
                {productData?.status}
              </div>
              <div className="col-sm-6 col-lg-4">
                <span className="text-muted fw-semibold">Quantity:</span>{" "}
                {productData?.quantity}
              </div>
            </div>
          </div>
          {/* Attachments */}
          <div className="pt-3">
            <p className="fs-5 fw-semibold mb-2">Attachments (Documents):</p>
            <div className="row g-4">
              <div className="col-12 col-md-4 col-lg-3">
                <p className="mb-2">Profile Image</p>
                <div
                  className="border border-1 d-flex justify-content-center align-items-center rounded p-2"
                  style={{ minHeight: "175px" }}
                >
                  <img
                    src={
                      productData?.profile_image_url
                        ? `https://estbn.com/EstbnNew/public${productData?.profile_image_url}`
                        : AddPhoto
                    }
                    style={{
                      width: "50%",
                      objectFit: "cover",
                    }}
                    alt="Profile"
                    className="rounded"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
